import { Component, computed, inject } from '@angular/core';
import { RestaurantConfigService } from '../../services/restaurant-config.service';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  private readonly restaurantConfig = inject(RestaurantConfigService);

  readonly profile = this.restaurantConfig.profile;
  readonly showReservation = computed(
    () => this.restaurantConfig.config().features.reservation
  );

  readonly heroBackground = computed(() => {
    const u = this.profile()?.heroImageUrl;
    return u ? `url('${u.replace(/'/g, "\\'")}')` : undefined;
  });

  scrollTo(anchor: string) {
    const el = document.getElementById(anchor);
    el?.scrollIntoView({ behavior: 'smooth' });
  }
}
